var RawDataComponent = /** @class */ (function () {
    function RawDataComponent() {
    }
    return RawDataComponent;
}());
export { RawDataComponent };
